<div class="menu">
    <core-helpers-navigation-three-dots-menu 
        [menu]="menu" (action)="onMenuClick($event)">
    </core-helpers-navigation-three-dots-menu>
</div>
<div [ngClass]="{'with-overlay': showRecord }">
    <core-layout-modal-record
        *ngIf="showRecord"
        [notificationData]="recordNotificationData"
        [buttonText]="'Start recording'"
        [leftButtonText]="'Cancel'"
        (action)="onRecordStart($event)"
        (leftButtonAction)="onRecordCancel($event)"
    ></core-layout-modal-record>
</div>
<core-message-add-form
    [hidden]="!show"
    [context]="context"
    [hash]="hash"
    [placeholder]="placeholder"
    (onSubmit)="onSubmit($event)"
    (onCancel)="onCancel()"
></core-message-add-form>

<div class="row">
    <core-helpers-box-loading [hidden]="!working"></core-helpers-box-loading>
    <core-helpers-box-success [hidden]="!success"></core-helpers-box-success>
    <div [hidden]="!error" class="alert-warning">
        <core-helpers-box-alert-message-icon
            [text]="'There was an error sending your message.'"
            [icon]="'alert'"
        ></core-helpers-box-alert-message-icon>
        <div class="fieldset">
        <core-helpers-forms-button-icon
            [text]="'Try again Now'"
            [icon]="''"
            (click)="try()"
        ></core-helpers-forms-button-icon>
        </div>
    </div>

</div>
